// Old /shell/* addresses → their current addresses.
//
// Menu review (Oct 2026): these used to render full copies of pages that
// now live at their own addresses, so one page had two URLs and the
// sidebar highlighted nothing on the old one. They forward instead,
// keeping the rest of the path (the caller adds search + hash).
//
// Still canonical under /shell and deliberately NOT listed here:
// /shell/copilot (Ask Athena), /shell/clients (MSSP), /shell/profile
// (avatar menu) and /shell/platform/* (superadmin). /shell/posture/* has
// its own redirect (ShellPostureRedirect, MP427).

export const SHELL_LEGACY_PREFIXES: Array<[string, string]> = [
  ['/shell/phishing', '/aware/phishing'],
  ['/shell/training', '/aware/training'],
  ['/shell/forum', '/aware/forum'],
  ['/shell/email-security', '/xes'],
  ['/shell/external-risk', '/surface/findings'],
  ['/shell/identity', '/identity'],
  ['/shell/integrations', '/integrations'],
  ['/shell/policies', '/policies'],
  ['/shell/settings', '/settings'],
  ['/shell/agents', '/agents'],
  ['/shell/risk', '/risk'],
  ['/shell/audit', '/audit'],
  ['/shell/help', '/help'],
  ['/shell', '/aware'],
];

export function shellLegacyTarget(pathname: string): string {
  for (const [from, to] of SHELL_LEGACY_PREFIXES) {
    if (pathname === from || pathname.startsWith(from + '/')) return to + pathname.slice(from.length);
  }
  return pathname;
}

